<template>
  <b-form-group
    :id="formGroupId"
    class="password-input-group"
  >
    <b-form-input
      id="user-password-input"
      v-model="password"
      :placeholder="placeholder"
      :type="isPasswordVisible ? 'text' : 'password'"
      size="sm"
      trim
      @input="updateValue"
    />
    <span
      class="password-show-toggle"
      @click="isPasswordVisible = !isPasswordVisible"
    >
      <BIconEye />
    </span>
  </b-form-group>
</template>

<script>
import {BIconEye} from 'bootstrap-vue';

export default {
  name: 'Password',
  components: {BIconEye},
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Passwort'
    },
    formGroupId: {
      type: String,
      default: 'password-input-group'
    }
  },
  data: function () {
    return {
      password: null,
      isPasswordVisible: false
    };
  },
  mounted() {
    this.password = this.value;
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style scoped>
  .password-show-toggle {
    position: absolute;
    top: 5px;
    right: 8px;
    cursor: pointer;
  }

  .password-input-group {
    position: relative;
  }
</style>
